import { USER_AVAILABLE_STATUS } from "@home-health-notify/domain";
import { FormControlLayout } from "../UserProfileModal.style";
import { FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { useTranslation } from "hhn-commons";

interface InputStatusProps {
  availableStatus: USER_AVAILABLE_STATUS;
  setAvailableStatus: (status: USER_AVAILABLE_STATUS) => void;
}

const InputStatus = ({
  availableStatus,
  setAvailableStatus,
}: InputStatusProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "userProfile" });

  return (
    <FormControlLayout>
      <FormLabel>Status</FormLabel>
      <RadioGroup
        row
        name="availableStatus"
        value={availableStatus}
        onChange={e =>
          setAvailableStatus(e.target.value as USER_AVAILABLE_STATUS)
        }
      >
        <FormControlLabel
          value={USER_AVAILABLE_STATUS.AVAILABLE}
          control={<Radio />}
          label={tNs("availableStatus.acceptingPatients")}
        />
        <FormControlLabel
          value={USER_AVAILABLE_STATUS.NOT_AVAILABLE}
          control={<Radio />}
          label={tNs("availableStatus.notAccepting")}
        />
      </RadioGroup>
    </FormControlLayout>
  );
};

export default InputStatus;
